(function() {
    'use strict';

    angular
        .module('remitEventsApp')
        .controller('EnergyEventDetailController', function(
            $state,
            $stateParams,
            $translate,
            $timeout,
            EventDetails,
            EventFilter,
            EventService
        ) {
            var vm = this;

            vm.events = [];
            vm.isIframe = $state.current.data.iframe;

            vm.translateRemarks = function() {
                var currentLang = $translate.use();
                return EventFilter.translateRemarks(vm.events, currentLang);
            };

            vm.translateReasons = function() {
                var currentLang = $translate.use();
                return EventFilter.translateReasons(vm.events, currentLang);
            };

            vm.scrollRightTable = function() {
                EventService.scrollTable(5, '.right-content-table');
            };

            vm.scrollLeftTable = function() {
                EventService.scrollTable(-5, '.right-content-table');
            };

            vm.stopScroll = function() {
                EventService.stopScroll();
            };

            vm.$onInit = function() {
                if ($stateParams.messageId) {
                    EventDetails.query({ messageId: $stateParams.messageId, noPage: 1 }, function(result) {
                        vm.events = result;
                    });
                } else {
                    EventDetails.query({ id: $stateParams.id, noPage: 1 }, function(result) {
                        vm.events = [result];
                    });
                }

                $timeout(function() {
                    EventService.setTablePosition();
                }, 500);
            };
        });
})();
